const ACTIONS_TYPES_FILE = "actions.d.ts";
const VIRTUAL_MODULE_ID = "astro:actions";
const RESOLVED_VIRTUAL_MODULE_ID = "\0" + VIRTUAL_MODULE_ID;
const ACTIONS_ENTRYPOINT_VIRTUAL_MODULE_ID = "virtual:astro:actions/entrypoint";
const ACTIONS_RESOLVED_ENTRYPOINT_VIRTUAL_MODULE_ID = "\0" + ACTIONS_ENTRYPOINT_VIRTUAL_MODULE_ID;
const OPTIONS_VIRTUAL_MODULE_ID = "virtual:astro:actions/options";
const RESOLVED_OPTIONS_VIRTUAL_MODULE_ID = "\0" + OPTIONS_VIRTUAL_MODULE_ID;
const RESOLVED_NOOP_ENTRYPOINT_VIRTUAL_MODULE_ID = "\0virtual:astro:actions/noop-entrypoint";
const ACTION_QUERY_PARAMS = {
  actionName: "_action",
  actionPayload: "_astroActionPayload"
};
const ACTION_RPC_ROUTE_PATTERN = "/_actions/[...path]";
export {
  ACTIONS_ENTRYPOINT_VIRTUAL_MODULE_ID,
  ACTIONS_RESOLVED_ENTRYPOINT_VIRTUAL_MODULE_ID,
  ACTIONS_TYPES_FILE,
  ACTION_QUERY_PARAMS,
  ACTION_RPC_ROUTE_PATTERN,
  OPTIONS_VIRTUAL_MODULE_ID,
  RESOLVED_NOOP_ENTRYPOINT_VIRTUAL_MODULE_ID,
  RESOLVED_OPTIONS_VIRTUAL_MODULE_ID,
  RESOLVED_VIRTUAL_MODULE_ID,
  VIRTUAL_MODULE_ID
};
